import { useNavigate } from 'react-router-dom';
import React, { useState, useEffect, Fragment } from 'react';
import { DashboardsBackOffice } from "../../../components/backgrounds/DashboardsBackoffice";
import { HttpRequest } from '../../../services/httpRequest';
import { SuccessAlert } from '../../../components/alerts/successAlert';
import { ErrorAlert } from '../../../components/alerts/errorAlert';
import { roleUser } from '../../../utils/roleUser';
import { DefaultSelect } from '../../../components/inputs/DefaultInput';
import { bankAccountOptions } from '../../../utils/options_selects';
import { APIClient } from '../../../helpers/api_helper';
import { CREATE_VERIFY_ACCOUNT } from '../../../helpers/url_helper';

const typeBankAccountOptions = [
    { value: "Selecciona una opción", label: "Selecciona una opción" },
    { value: "Ahorros", label: "Ahorros" },
    { value: "Corriente", label: "Corriente" }
];

const apiClient = new APIClient();

export function CreateVerifyAccount() {

    const navigate = useNavigate();
    const [messsageAlert, setMessageAlert] = useState("");
    const [isOpenSuccess, setIsOpenSuccess] = useState();
    const [isOpenError, setIsOpenError] = useState();
    const [viewalert, setViewalert] = useState(false);
    const [formData, setFormData] = useState({
        bankAccount: "",
        typeBankAccount: "",
        accountNumber: "",
        category: "parent",
        disbursementCount: 1
    });
    const [documento, setDocumento] = useState("");
    const [errors, setErrors] = useState({});

    const getInfoRole = async (doc) => {
        try {
            let response = await HttpRequest.getInfoRole(doc);
            return response.message;
        } catch (error) {
            console.log(error);
            return {}
        }
    }

    const handleOpenAlert = (type, message, isOpen) => {
        if (type === 'success') {
            setMessageAlert(message);
            setIsOpenSuccess(isOpen);
            setViewalert(true);
        }
        if (type === 'error') {
            setMessageAlert(message);
            setIsOpenError(isOpen);
            setViewalert(true);
        }
    }

    const handleClearStateAlert = () => {
        setViewalert(false);
        setMessageAlert("");
        setIsOpenSuccess(false);
        setIsOpenError(false);
    }

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
    };

    const handleSubmit = async (e) => {
        try {
            handleClearStateAlert();
            e.preventDefault();
            if (!validateInputs()) return;
            let payload = { documento, accounts: [formData] };
            let { data } = await apiClient.create(CREATE_VERIFY_ACCOUNT, payload);
            if (data?.success === true) {
                handleOpenAlert('success', 'Cuenta verificada creada exitosamente!', true);
            } else {
                handleOpenAlert('error', data?.message || "Error interno.", true);
            }
        } catch (error) {
            console.log(error);
            handleOpenAlert('error', error, true);
        } finally {
            setFormData({
                bankAccount: "",
                typeBankAccount: "",
                accountNumber: "",
                category: "parent",
                disbursementCount: 1
            });
            setDocumento("");
            setTimeout(() => {
                handleClearStateAlert()
            }, 6000);
        }
    };

    const handleChangeBankAccount = (e) => {
        setFormData({
            ...formData,
            bankAccount: e.target.value,
        });
    };

    const handleChangeTypeBankAccount = (e) => {
        setFormData({
            ...formData,
            typeBankAccount: e.target.value,
        });
    };

    const validateInputs = () => {

        const newErrors = {};
        const isNumeric = /^\d+$/;

        if (!documento || documento === '') {
            newErrors.documento = 'El documento es requerido.';
        }

        if (!formData.bankAccount || formData.bankAccount === '' || formData.bankAccount === 'Selecciona una opción') {
            newErrors.bankAccount = 'El banco es requerido.';
        }

        if (!formData.typeBankAccount || formData.typeBankAccount === '' || formData.typeBankAccount === 'Selecciona una opción') {
            newErrors.typeBankAccount = 'El tipo de cuenta es requerido.';
        }

        if (!formData.accountNumber || formData.accountNumber === '') {
            newErrors.accountNumber = 'El número de cuenta es requerido.';
        }

        if (!isNumeric.test(formData.accountNumber)) {
            newErrors.accountNumber = 'El número de cuenta es inválido.';
        }

        setErrors(newErrors);

        return Object.keys(newErrors).length === 0; // Devuelve true si no hay errores
    }

    useEffect(() => {
        let doc = localStorage.getItem('doc');
        if (typeof doc !== 'string') {
            return navigate('/ingresar');
        } else {
            getInfoRole(doc)
                .then((infoRole) => {
                    if (infoRole?.error === true) return navigate('/ingresar');
                    if ('user' in infoRole) {
                        let user = infoRole.user;

                        if (user?.roleUser === roleUser.admin) {
                            console.log('User authorized...');
                        } else {
                            alert('No esta autorizado para ver esta página.');
                            setTimeout(() => {
                                return navigate('/ingresar');
                            }, 2000);
                        }
                    } else {
                        return navigate('/ingresar');
                    }
                })
                .catch(e => console.log(e))
        }

    }, [])

    return (
        <Fragment>
            {
                viewalert ?
                    <>
                        <SuccessAlert isOpen={isOpenSuccess} message={messsageAlert}></SuccessAlert>
                        <ErrorAlert isOpen={isOpenError} message={messsageAlert}></ErrorAlert>
                    </>
                    : <></>
            }

            <DashboardsBackOffice
                name={'Admin'}
                balance={0}
                current10={true}
                title={'Crear cuenta verificada'}
                main={
                    <>
                        <form action="#" method="POST">
                            <div className='px-4 mt-3 py-5 bg-white sm:p-6' style={{ borderRadius: '5px' }}>

                                <div className="grid grid-cols-8 gap-6">
                                    <div className="col-span-4 sm:col-span-4 mt-4">
                                        <label
                                            htmlFor="document"
                                            className="block text-sm font-medium"
                                        >
                                            Documento de identidad
                                        </label>
                                        <div>
                                            <input
                                                value={documento}
                                                onChange={(e) => setDocumento(e.target.value)}
                                                type="number"
                                                name="documento"
                                                id="documento"
                                                maxLength="40"
                                                className="py-2 px-4 block w-full border-0 border-b focus:border-purple focus:ring-0 sm:text-base"
                                            />
                                        </div>
                                        {errors.documento && (<span className="text-sm" style={{ color: "#fc3e58", fontStyle: "italic" }}>{errors.documento}</span>)}
                                    </div>

                                    <div className="col-span-4 sm:col-span-4 mt-4">
                                        <label
                                            htmlFor="cellPhone"
                                            className="block text-sm font-medium"
                                        >
                                            Banco
                                        </label>
                                        <div>
                                            <DefaultSelect
                                                option={bankAccountOptions}
                                                onChange={handleChangeBankAccount}
                                                value={formData.bankAccount}
                                            />
                                        </div>
                                        {errors.bankAccount && (<span className="text-sm" style={{ color: "#fc3e58", fontStyle: "italic" }}>{errors.bankAccount}</span>)}
                                    </div>
                                </div>


                                <div className="grid grid-cols-8 gap-6">
                                    <div className="col-span-4 sm:col-span-4 mt-4">
                                        <label
                                            htmlFor="document"
                                            className="block text-sm font-medium"
                                        >
                                            Tipo de cuenta
                                        </label>
                                        <div>
                                            <DefaultSelect
                                                option={typeBankAccountOptions}
                                                onChange={handleChangeTypeBankAccount}
                                                value={formData.typeBankAccount}
                                            />
                                        </div>
                                        {errors.typeBankAccount && (<span className="text-sm" style={{ color: "#fc3e58", fontStyle: "italic" }}>{errors.typeBankAccount}</span>)}
                                    </div>

                                    <div className="col-span-4 sm:col-span-4 mt-4">
                                        <label
                                            htmlFor="cellPhone"
                                            className="block text-sm font-medium"
                                        >
                                            Número de cuenta
                                        </label>
                                        <div>
                                            <input
                                                value={formData.accountNumber}
                                                onChange={handleChange}
                                                type="number"
                                                name="accountNumber"
                                                id="accountNumber"
                                                maxLength="40"
                                                className="py-2 px-4 block w-full border-0 border-b focus:border-purple focus:ring-0 sm:text-base"
                                            />
                                        </div>
                                        {errors.accountNumber && (<span className="text-sm" style={{ color: "#fc3e58", fontStyle: "italic" }}>{errors.accountNumber}</span>)}
                                    </div>
                                </div>

                                <div className="md:w-56 pt-3 mt-3">
                                    <button
                                        onClick={handleSubmit}
                                        type="button"
                                        className="w-full flex justify-center py-2 px-4 border border-transparent rounded-full shadow-sm text-xl font-medium text-white bg-green transition duration-300 hover:bg-greenDark focus:outline-none"
                                    >
                                        <div className="flex">
                                            {'Guardar'}
                                            <div className="grid content-center pl-2">{ }</div>
                                        </div>
                                    </button>
                                </div>

                            </div>
                        </form>

                    </>
                }
            />

        </Fragment>
    );
}
